
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/prime.css";
import useInput from "hooks/use-input";
import './mod.scss';
import Select, { StylesConfig } from "react-select";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
function AddScore({ setUpdater, updater }) {
  const title = useInput((value) => value.trim() !== "");
  const options = [
    { value: '1', label: 'همکاری در فروش' },
    { value: '2', label: 'ارجاع' },
    { value: '3', label: 'عضو شدن' },
    { value: '4', label: 'بازدید' },
    { value: '5', label: 'خرید' },
    { value: '6', label: 'کامنت محصول' },
    { value: '7', label: 'کامنت سفارش' },
  ]
  return (
    <>
      <div
        class="modal fade"
        id={`exampleModalLabelScore`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        dir="rtl"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                اضافه کردن امتیاز
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="modd w-100">
              <div
                      className="d-flex align-items-baseline mb-3 w-100"
                     
                    >
                      <label
                       
                        htmlFor="shop-main_admin_uid"
                        className="form-label mx-2"
                        style={{width:"110px"}}
                      >
                         کاربر : 
                      </label>
                      <div className="w-100" style={{width:"100% !important"}}>
                        <input
                          id="tags"
                          className=" filterSelect w-100 "
                          style={{ background: "#ddd" , border:"2px solid #ddd",height:"40px", borderRadius:"3px",  outline:"none"}}
                         
                        />
                      </div>
                    </div>
                    <div
                      className="d-flex align-items-baseline mb-3 w-100"
                     
                    >
                      <label
                       
                        htmlFor="shop-main_admin_uid"
                        className="form-label mx-2"
                        style={{width:"110px"}}
                      >
                         امتیاز : 
                      </label>
                      <div className="w-100" style={{width:"100% !important"}}>
                        <input
                          id="tags"
                          className=" filterSelect w-100 "
                          style={{ background: "#ddd" , border:"2px solid #ddd",height:"40px", borderRadius:"3px",  outline:"none"}}
                         
                        />
                      </div>
                    </div>  <div
                      className="d-flex align-items-baseline mb-3 w-100"
                     
                    >
                      <label
                       
                        htmlFor="shop-main_admin_uid"
                        className="form-label mx-2"
                        style={{width:"110px"}}
                      >
                         موبایل : 
                      </label>
                      <div className="w-100" style={{width:"100% !important"}}>
                        <input
                          id="tags"
                          className=" filterSelect w-100 "
                          style={{ background: "#ddd" , border:"2px solid #ddd",height:"40px", borderRadius:"3px",  outline:"none"}}
                         
                        />
                      </div>
                    </div>
                    <div
                      className="d-flex align-items-baseline mb-3 w-100"
                     
                    >
                      <label
                       
                        htmlFor="shop-main_admin_uid"
                        className="form-label mx-2"
                        style={{width:"110px"}}
                      >
                        نوع : 
                      </label>
                      <div className="w-100" style={{width:"100% !important"}}>
                        <Select
                          id="tags"
                          className=" filterSelect w-100 "
                          options={options}
                          // options={tagsOptions}
                          isMulti={true}
                          style={{ background: "#ddd" }}
                          // value={defaultTags}
                        />
                      </div>
                    </div>
               
                   
                    <div
                      className="d-flex align-items-baseline mb-3 w-100"
                     
                    >
                      <label
                       
                        htmlFor="shop-main_admin_uid"
                        className="form-label mx-2"
                        style={{width:"110px"}}
                      >
                        زمان انجام : 
                      </label>
                      <div className="boxDate">
            <DatePicker className="rmdp-prime" 
            showOtherDays calendar={persian} locale={persian_fa} 
            calendarPosition="bottom-right" />
          </div>
                    </div>
              </div>

            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
               
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  
                }}
               
                
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddScore;
